import { render, staticRenderFns } from "./CardexTable.vue?vue&type=template&id=77951f79&"
import script from "./CardexTable.vue?vue&type=script&lang=js&"
export * from "./CardexTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard})
